import { create } from "zustand";

interface LoadingState {
  loadingStates: Record<string, boolean>;
  setLoading: (key: string, isLoading: boolean) => void;
  isLoading: (key?: string) => boolean;
  isAnyLoading: () => boolean;
  clearAll: () => void;
}

export const useLoadingStore = create<LoadingState>((set, get) => ({
  loadingStates: {},

  // Set loading state cho một key cụ thể
  setLoading: (key: string, isLoading: boolean) => {
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [key]: isLoading,
      },
    }));
  },

  // Check loading state của một key cụ thể
  isLoading: (key?: string) => {
    if (!key) return get().isAnyLoading();
    return get().loadingStates[key] || false;
  },

  // Check xem có bất kỳ loading nào đang active không
  isAnyLoading: () => {
    const states = get().loadingStates;
    return Object.values(states).some((loading) => loading);
  },

  // Clear tất cả loading states
  clearAll: () => {
    set({ loadingStates: {} });
  },
}));

// Loading keys constants để dễ quản lý
export const LOADING_KEYS = {
  AUTH_LOGIN: "auth_login",
  AUTH_REGISTER: "auth_register",
  AUTH_LOGOUT: "auth_logout",
  USER_PROFILE: "user_profile",
  FETCH_ORDERS: "fetch_orders",
  FETCH_PACKAGES: "fetch_packages",
  FETCH_PAYMENTS: "fetch_payments",
  CREATE_ORDER: "create_order",
  UPDATE_PROFILE: "update_profile",
  UPLOAD_FILE: "upload_file",
  FETCH_CONFIG: "fetch_config",
  GENERATE_API: "generate_api",
} as const;

export type LoadingKey = (typeof LOADING_KEYS)[keyof typeof LOADING_KEYS];
